import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  Grid,
  Tooltip,
  Table,
  TableRow,
  TableCell,
  Button,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";
import { useAuthUser } from "react-auth-kit";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import AgentGroupCard from "app/campaigns/components/agent_groups";
import PricePlansCard from "app/campaigns/components/pricing";
import CampaignViewsCard from "app/campaigns/components/campaign_view";

function DawManagePage() {
  const pageTitle = "Display & Win";
  usePageTitle(pageTitle);
  const navigate = useNavigate();
  const { ref } = useParams();
  const auth = useAuthUser();
  const accountInfo = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  function triggerRefresh() {
    setRefreshPage((prev) => !prev);
  }

  const [resultData, setResultData] = useState({});
  const [campaign, setCampaign] = useState({});
  const [products, setProducts] = useState([]);
  const [campaignTitle, setCampaignTitle] = useState(null);
  const [campaignVisitInterval, setCampaignVisitInterval] = useState(null);
  const [campaignRetailerTarget, setCampaignRetailerTarget] = useState(null);
  const [campaignEndDate, setCampaignEndDate] = useState(null);

  const [productTitle, setProductTitle] = useState(null);
  const [productPoints, setProductPoints] = useState(null);
  const [productPrice, setProductPrice] = useState(null);
  const [productDisplayQuantity, setProductDisplayQuantity] = useState(null);
  const [productImage, setProductImage] = useState(null);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productAction, setProductAction] = useState("create");
  const [openAddProductDialog, setOpenAddProductDialog] = useState(false);

  async function deleteProduct(reference) {
    setShowLoading(true);
    await axios
      .get(`portal/daw/products/${reference}/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const productsTableColumns = [
    { Header: "Name", accessor: "title", align: "left" },
    { Header: "Price", accessor: "price", align: "left" },
    { Header: "Display Quantity", accessor: "qty", align: "left" },
    { Header: "Visit Points", accessor: "points", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        title: row.title,
        price: row.price / 100,
        qty: row.min_display_qty,
        points: row.points,
        actions: (
          <MDBox mt={1} variant="button">
            <Tooltip title="Edit">
              <MDButton
                size="small"
                variant="outlined"
                color="warning"
                iconOnly
                onClick={() => {
                  setProductTitle(row.title);
                  setProductDisplayQuantity(row.min_display_qty);
                  setProductPoints(row.points);
                  setProductPrice(row.price / 100);

                  setSelectedProduct(row.reference);
                  setProductAction("edit");
                  setOpenAddProductDialog(true);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small">
                  edit
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Delete?`) === true) {
                  deleteProduct(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/daw/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result.data.data.campaign.activation);
          setShowLoading(false);
          if (result.data.status === "success") {
            setResultData(result.data.data.campaign.campaign);
            setCampaign(result.data.data.campaign.activation);
            setCampaignTitle(result.data.data.campaign.activation.title);
            setCampaignVisitInterval(result.data.data.campaign.activation.visit_interval);
            setCampaignRetailerTarget(result.data.data.campaign.activation.retailer_count_target);
            setCampaignEndDate(result.data.data.campaign.activation.end_date);

            const rows = buildRows(result.data.data.products);
            setProducts(rows);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function updateCampaign() {
    if (campaignTitle === null) {
      setSeverity("error");
      setErrMsg("Campaign name is invalid.");
      setOpen(true);
      return;
    }

    if (campaignRetailerTarget === null) {
      setSeverity("error");
      setErrMsg("Campaign retailer target number is invalid.");
      setOpen(true);
      return;
    }

    if (campaignVisitInterval === null) {
      setSeverity("error");
      setErrMsg("Visit interval is invalid.");
      setOpen(true);
      return;
    }

    if (campaignEndDate === null) {
      setSeverity("error");
      setErrMsg("End date is invalid.");
      setOpen(true);
      return;
    }

    setShowLoading(true);

    const json = {
      reference: ref,
      title: campaignTitle,
      interval: campaignVisitInterval,
      retailers: campaignRetailerTarget,
      end_date: campaignEndDate,
    };

    await axios
      .post(`portal/daw/update.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createProduct() {
    if (productTitle === null) {
      setSeverity("error");
      setErrMsg("Product name is invalid.");
      setOpen(true);
      return;
    }

    if (productPrice === null) {
      setSeverity("error");
      setErrMsg("Product price is invalid.");
      setOpen(true);
      return;
    }

    if (productPoints === null) {
      setSeverity("error");
      setErrMsg("Visit reward points is invalid.");
      setOpen(true);
      return;
    }

    if (productDisplayQuantity === null) {
      setSeverity("error");
      setErrMsg("Minimum required display quantity is invalid.");
      setOpen(true);
      return;
    }

    setOpenAddProductDialog(false);
    setShowLoading(true);

    let json = {
      reference: ref,
      title: productTitle,
      price: parseFloat(productPrice, 10) * 100,
      points: productPoints,
      min_display_quantity: productDisplayQuantity,
    };
    let url = "create";

    if (productAction === "create") {
      json["reference"] = ref;
    } else {
      json["reference"] = selectedProduct;
      url = "update";
    }

    await axios
      .post(`portal/daw/products/${url}.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openAddProductDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>{productAction === "create" ? "Create" : "Edit"} Product</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Product Name"
                type="text"
                fullWidth
                variant="outlined"
                value={productTitle}
                onChange={(e) => setProductTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Product Price"
                type="text"
                fullWidth
                variant="outlined"
                value={productPrice}
                onChange={(e) => setProductPrice(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Visit Points"
                type="text"
                fullWidth
                variant="outlined"
                value={productPoints}
                onChange={(e) => setProductPoints(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Minimum Display Quantity"
                type="text"
                fullWidth
                variant="outlined"
                value={productDisplayQuantity}
                onChange={(e) => setProductDisplayQuantity(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddProductDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              createProduct();
            }}
          >
            {productAction === "create" ? "Add" : "Update"}
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox mt={1} mb={2} display="flex" justifyContent="space-between">
              <MDBox>
                <Button
                  color="dark"
                  size="small"
                  startIcon={<Icon>west</Icon>}
                  onClick={() => {
                    navigate(`/campaigns`);
                  }}
                >
                  Back
                </Button>
              </MDBox>
              <MDBox>
                <Button
                  size="small"
                  color="info"
                  iconOnly
                  onClick={() => {
                    navigate(`/trade-marketing/promotions/display-win/retailers/${ref}`);
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      storefront
                    </Icon>
                  }
                >
                  Retailers
                </Button>
                &nbsp;
                <Button
                  size="small"
                  color="info"
                  iconOnly
                  onClick={() => {
                    navigate(`/trade-marketing/promotions/display-win/visits/${ref}`);
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      where_to_vote
                    </Icon>
                  }
                >
                  Visits
                </Button>
                &nbsp;
                <Button
                  size="small"
                  color="info"
                  iconOnly
                  onClick={() => {
                    navigate(`/trade-marketing/promotions/display-win/leaderboard/${ref}`);
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      leaderboard
                    </Icon>
                  }
                >
                  Leaderboard
                </Button>
                &nbsp;
                <Button
                  size="small"
                  color="error"
                  iconOnly
                  onClick={() => {
                    if (window.confirm(`Terminate this campaign?`) === true) {
                      navigate(`/trade-marketing/promotions/display-win`);
                    }
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      delete
                    </Icon>
                  }
                >
                  Terminate
                </Button>
              </MDBox>
            </MDBox>
            <MDBox mt={1}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={7} lg={7}>
                  <Card>
                    <MDBox p={2}>
                      <MDBox>
                        <MDTypography variant="h6">Activation Information</MDTypography>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDInput
                          value={campaignTitle}
                          name="title"
                          margin="dense"
                          label="Campaign Name"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setCampaignTitle(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mt={4}>
                        <Grid container spacing={3}>
                          <Grid item xs={4} md={4} lg={4}>
                            <MDInput
                              value={campaignVisitInterval}
                              name="title"
                              margin="dense"
                              label="Visit Interval (Days)"
                              type="text"
                              fullWidth
                              variant="outlined"
                              onChange={(e) => setCampaignVisitInterval(e.target.value)}
                            />
                          </Grid>
                          <Grid item xs={4} md={4} lg={4}>
                            <MDInput
                              value={campaignRetailerTarget}
                              name="title"
                              margin="dense"
                              label="Retailers Target"
                              type="text"
                              fullWidth
                              variant="outlined"
                              onChange={(e) => setCampaignRetailerTarget(e.target.value)}
                            />
                          </Grid>
                          <Grid item xs={4} md={4} lg={4}>
                            <MDInput
                              value={campaignEndDate}
                              name="title"
                              margin="dense"
                              label="End Date"
                              type="date"
                              fullWidth
                              variant="outlined"
                              onChange={(e) => setCampaignEndDate(e.target.value)}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </Grid>
                        </Grid>
                      </MDBox>
                      <MDBox mt={3} align="right">
                        <MDButton variant="contained" color="dark" onClick={() => updateCampaign()}>
                          Save Changes
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
                <Grid item xs={12} md={5} lg={5}>
                  <Card>
                    <MDBox p={2}>
                      <MDBox>
                        <MDTypography variant="h6">Quick Guide</MDTypography>
                      </MDBox>
                      <MDBox mt={1} px={2}>
                        <MDTypography variant="subtitle2" fontSize={14}>
                          <ul>
                            <li>Set your target number of retailers to onboard</li>
                            <li>Set an interval in days between each retailer visit.</li>

                            <li>
                              Add products to be displayed at retailer outlets. Set reward points
                              and minimum display quantity eligible for earning points.
                            </li>
                            <li>
                              Group and Assign agents to this campaign. Go to team management to add
                              your agents.
                            </li>
                            <li>
                              Optionally, you can work with supervisors, and have their agents
                              participate in this campaign.
                            </li>
                            {accountInfo.account.plan.code === "PAG" && (
                              <li>Activate this campaign and monitor results.</li>
                            )}
                          </ul>
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Products
                        </MDTypography>
                      </MDBox>
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          iconOnly
                          onClick={() => {
                            setProductTitle(null);
                            setProductDisplayQuantity(null);
                            setProductPoints(null);
                            setProductPrice(null);

                            setProductAction("create");
                            setOpenAddProductDialog(true);
                          }}
                        >
                          <Icon>add</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  <MDBox p={0}>
                    <DataTable
                      table={{ columns: productsTableColumns, rows: products }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox>
              <AgentGroupCard
                campaignRef={ref}
                agentGroups={resultData.agent_groups}
                campaignAgentGroups={resultData.super_agents}
                aggregators={resultData.aggregators}
                campaignAggregators={resultData.campaign_aggregators}
                triggerRefresh={triggerRefresh}
              />
            </MDBox>
            <MDBox mt={3}>
              <CampaignViewsCard
                campaignRef={ref}
                triggerRefresh={triggerRefresh}
                campaignViews={resultData.campaign_views}
              />
            </MDBox>
            {accountInfo.account.plan.code === "PAG" && (
              <MDBox mt={3}>
                <PricePlansCard
                  campaignRef={ref}
                  triggerRefresh={triggerRefresh}
                  packages={resultData.packages}
                  campaignPackage={resultData.campaign_package}
                  campaignType={campaign.campaign_type}
                  currency={resultData.currency}
                />
              </MDBox>
            )}
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DawManagePage;
